<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import HeroHomeVideo from 'components/hero/hero-home-video/hero-home-video'
import RepeaterLogos from 'components/repeater/repeater-logos/repeater-logos'
import BlockTitleContent from 'components/block/block-title-content/block-title-content'
import CustomHomeBowlSection from 'components/custom/custom-home-bowl-section/custom-home-bowl-section'
import DividerSignUp from 'components/divider/divider-sign-up/divider-sign-up'
import CustomHomeInstagram from 'components/custom/custom-home-instagram/custom-home-instagram'
import CustomHomeLocation from 'components/custom/custom-home-location/custom-home-location'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    HeroHomeVideo,
    RepeaterLogos,
    BlockTitleContent,
    CustomHomeBowlSection,
    DividerSignUp,
    CustomHomeInstagram,
    Loader,
    CustomHomeLocation
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/home.vue